import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { signOutSubmit } from "../../redux/features/auth/authService";
import { useTranslation } from "react-i18next";
import { showToast } from "../ToastMsg";

const pages = [
    { name: "Home", path: "/" },
    { name: "Results", path: "/results" },
    { name: "Winners", path: "/winners" },
    { name: "About Us", path: "/about" },
    { name: "Contact", path: "/contact" }
];

const Sidebar = ({ isSidebarOpen, closeSidebar }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const { hasCheckedAuth, details } = useSelector(selectUserDetails);

    const toggleLogin = () => navigate('/auth/login');
    const toggleReg = () => navigate('/auth/register');

    useEffect(() => {
        document.addEventListener("mousedown", closeSidebar);
        return () => {
            document.removeEventListener("mousedown", closeSidebar);
        };
    }, []);

    const handleLogout = () => {
        dispatch(signOutSubmit())
            .unwrap()
            .then(() => {
                navigate('/');
            })
            .catch((error) => {
                showToast("error", error.message);
            });
    }


    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.headingSec}>
                    <div className={styles.logoSec}>
                        <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                    </div>
                    <div className={styles.topSec}>
                        <div className={styles.barIcon} onClick={closeSidebar}>
                            <FontAwesomeIcon icon={faBars} size="lg" style={{ color: '#1D0C50', marginTop: '0px' }} />
                        </div>
                    </div>
                </div>
                {hasCheckedAuth && (
                    details.id ? (
                        <></>
                    ) : (
                        <div className={styles.btnSec}>
                            <button type="button" className={styles.loginBtn} onClick={toggleLogin}>{t('Login')}</button>
                            <button type="button" className={styles.regBtn} onClick={toggleReg}>{t('Register')}</button>
                        </div>
                    )
                )}
                <ul className={styles.sidebarMenu}>
                    {pages.map(({ name, path }) => (
                        <li key={name}>
                            <NavLink to={path} className={({ isActive }) =>
                                `${isActive ? styles.active : ""} ${i18n.language === 'ta' ? styles.tamil : ""}`
                            }>
                                {t(name)}
                            </NavLink>
                        </li>
                    ))}
                    {hasCheckedAuth && (
                        details.id && (
                            <>
                                <li>
                                    <NavLink to={'/my-profile'} className={({ isActive }) =>
                                        `${isActive ? styles.active : ""} ${i18n.language === 'ta' ? styles.tamil : ""}`
                                    }>
                                        {t('Profile')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={'/wallet'} className={({ isActive }) =>
                                        `${isActive ? styles.active : ""} ${i18n.language === 'ta' ? styles.tamil : ""}`
                                    }>
                                        {t('Wallet')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={'/my-tickets'} className={({ isActive }) =>
                                        `${isActive ? styles.active : ""} ${i18n.language === 'ta' ? styles.tamil : ""}`
                                    }>
                                        {t('Ticket')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={'/subscriptions'} className={({ isActive }) =>
                                        `${isActive ? styles.active : ""} ${i18n.language === 'ta' ? styles.tamil : ""}`
                                    }>
                                        {t('Subscription')}
                                    </NavLink>
                                </li>
                                <li onClick={handleLogout} className={styles.dropdownItem}>
                                    {t('Logout')}
                                </li>
                            </>
                        ))}
                </ul>
            </div>
        </>
    );
};

export default Sidebar;
